import { Box, Card, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CardHeader, CardMedium } from '../../../../app/AppStyles';
import EmployeeTJLDisplay from '../../../flags/EmployeeTJLDisplay';
import FlagDisplay from '../../../flags/FlagDisplay';
import ProgressActivities from '../../../progress/ProgressActivities';
import ProgressActivitiesFuture from '../../../progress/ProgressActivitiesFuture';
import ProgressBar from '../../../progress/ProgressBar';
import ProgressProgramDisplay from '../../../progress/ProgressProgramDisplay';
import ProgressRemarks from '../../../progress/ProgressRemarks';

export default function SearchStudentProgressTab({ studentId }) {
    const { activeThemeSettings, activeDepartment, defaultTheme } = useSelector((state) => state.settings.theme);
    const { searchStudent } = useSelector((state) => state.search.student);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { appSettings } = useSelector((state) => state.settings.app);

    const [showTJL, setShowTJL] = useState(false);
    const [tjlStyle, setTJLStyle] = useState();

    useEffect(() => {
        if (appSettings?.appVersion === 1) {
            if (siomSettings.useMultipleDepartments) {
                if (activeDepartment?.[0].themeSettings?.tjlEnabled) {
                    setShowTJL(true);
                    setTJLStyle(activeDepartment?.[0].themeSettings?.tjlStyle);
                }
            } else {
                if (defaultTheme?.tjlEnabled) {
                    setShowTJL(true);
                    setTJLStyle(defaultTheme?.tjlStyle);
                }
            };
        }
    }, [appSettings, siomSettings]);

    return (
        <Grid container spacing={1} size={{ xs: 12 }}>
            {searchStudent?.studentProgress?.totalProgramCompleted &&
                <Grid size={{ xs: 12 }} sx={{ display: 'flex' }}>
                    <Card elevation={0} sx={{ ...CardMedium, display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold', color: 'success.main' }}>
                            {resourceFinal[appLanguage].messages.PROGRESS_PROGRAM_COMPLETED}
                        </Typography>
                    </Card>
                </Grid>
            }
            {searchStudent?.studentProgress &&
                <Grid size={{ xs: 12, md: activeThemeSettings.flagsEnabled ? 8 : 12 }} sx={{ display: 'flex' }}>
                    <Card elevation={0} sx={{ ...CardMedium, display: 'flex' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', flex: '1 1 auto', }}>
                            <Box sx={{ flex: '1 1 auto' }}>
                                <ProgressBar progressPoints={searchStudent?.studentProgress?.totalPoints} legendDisplay={true} barHeight={180} />
                            </Box>
                        </Box>
                    </Card>
                </Grid>
            }
            {(activeThemeSettings.flagsEnabled && searchStudent?.studentProgress) &&
                <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex' }}>
                    <Card elevation={0} sx={{ ...CardMedium }}>
                        <FlagDisplay progressFlags={searchStudent?.studentProgress?.progressFlags} requiredPoints={searchStudent?.studentProgress?.requiredPoints} xsIconSize={60} mdIconSize={60} compact={false} employeeMode />
                    </Card>
                </Grid>
            }
            {searchStudent?.studentProgress &&
                <Grid size={{ xs: 12 }} sx={{ display: 'flex' }}>
                    <Card elevation={0} sx={{ ...CardMedium }}>
                        <Typography variant="h6" sx={{ ...CardHeader }}>{resourceFinal[appLanguage].messages.CURRENT_CLINICS}</Typography>
                        <ProgressActivities progressActivities={searchStudent?.studentProgress?.progressActivities} employeeMode employeeStudentId={studentId} />
                    </Card>
                </Grid>
            }
            {(searchStudent?.studentProgress && siomSettings?.enableSubscriptionOutsideProgram) &&
                <Grid size={{ xs: 12 }} sx={{ display: 'flex' }}>
                    <Card elevation={0} sx={{ ...CardMedium }}>
                        <Typography variant="h6" gutterBottom sx={{ ...CardHeader }}>{resourceFinal[appLanguage].messages.FUTURE_CLINICS}</Typography>
                        <ProgressActivitiesFuture progressActivities={searchStudent?.studentProgress?.progressActivitiesFuture} employeeMode employeeStudentId={studentId} />
                    </Card>
                </Grid>
            }
            {searchStudent?.studentProgress?.progressRemarks.remarksCount > 0 &&
                <Grid size={{ xs: 12 }} sx={{ display: 'flex' }}>
                    <Card elevation={0} sx={{ ...CardMedium }}>
                        <Typography variant="h6" sx={{ ...CardHeader }}>{resourceFinal[appLanguage].words.REMARKS} ({searchStudent?.studentProgress?.progressRemarks.remarksCount})</Typography>
                        <ProgressRemarks remarks={searchStudent?.studentProgress?.progressRemarks.remarks} />
                    </Card>
                </Grid>
            }
            {searchStudent?.studentProgress &&
                <Grid size={{ xs: 12 }}>
                    <ProgressProgramDisplay progressProgram={searchStudent?.studentProgress?.progressProgram} />
                </Grid>
            }
            {!searchStudent?.studentProgress &&
                <Grid size={{ xs: 12 }}>
                    <Card elevation={0} sx={{ ...CardMedium }}>
                        <Typography variant="body1" textAlign="center">{resourceFinal[appLanguage].messages.SEARCH_STUDENT_NO_CONTENT}</Typography>
                        <Typography variant="body1" textAlign="center">{resourceFinal[appLanguage].messages.SEARCH_STUDENT_NO_CONTENT_REASON}</Typography>
                        {showTJL && <EmployeeTJLDisplay lifestyleStatus={searchStudent?.tjlStatus} tjlStyle={tjlStyle} />}
                    </Card>
                </Grid>
            }
        </Grid>
    );
}
